import {useFormContext} from "react-hook-form";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {FormLabel} from "@/components/form/FormLabel.tsx";

import {CreateCredentialFormValues} from "./CredentialCreateForm.tsx";
import {UpdateCredentialFormValues} from "./CredentialUpdateForm.tsx";

export const CredentialFormDisplayNameDescriptionInputs = () => {
  const {
    register,
    formState: {errors},
  } = useFormContext<CreateCredentialFormValues | UpdateCredentialFormValues>();
  const {user} = useCurrentUserContext();

  return (
    <>
      <div className="form-group my-2">
        <FormLabel forId="name" required={true}>
          Name
        </FormLabel>
        <input
          id="name"
          disabled={user?.has_write_access === false}
          className="form-control"
          type="text"
          {...register("display_name")}
        />
        {errors.display_name && <div className="invalid-feedback d-block">{errors.display_name?.message}</div>}
      </div>
      <div className="form-group my-2">
        <FormLabel forId="description">Description</FormLabel>
        <textarea
          id="description"
          disabled={user?.has_write_access === false}
          className="form-control"
          {...register("description")}
        />
        {errors.description && <div className="invalid-feedback d-block">{errors.description?.message}</div>}
      </div>
    </>
  );
};
